"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    radioButtonWrapper: {},
    radioButtonHorizontal: {
        flexDirection: 'row',
    },
    radioButtonItem: {
        flexDirection: 'column',
        marginBottom: 5,
        alignItems: 'center',
    },
    checkWrapper: {
        width: 16,
        height: 16,
        borderRadius: 8,
        borderWidth: 1,
        borderStyle: 'solid',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 5,
    },
    check: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: 'transparent',
    },
    labelWrapper: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    labelHorizontal: {
        flexDirection: 'row',
    },
};
